module.exports = __webpack_public_path__ + "img/pwa-role-bind.2a5411f2.png";